import { star_api_star_url } from "@/mk/urls/functions";

export function saveStar(xhr, entity, id, isStarred) {
    return xhr.post(star_api_star_url(entity, id), { isStarred });
}
